import * as React from 'react';

import { useTranslations } from '@rematter/modules/trade/i18n/useTranslations';
import { IconButton } from '@rematter/ui-web';
import { Trash2 } from 'lucide-react';

import { LoadStagedFieldProps } from '../_types';

export const DeleteButtonField: React.FC<LoadStagedFieldProps> = ({
  lineItem,
  disabled,
  onDeleteItem,
  onFocus,
  onBlur,
}) => {
  const t = useTranslations();
  const handleDeletePress = React.useCallback(() => {
    onDeleteItem(lineItem.id);
  }, [lineItem.id, onDeleteItem]);

  return (
    <div onFocus={onFocus} onBlur={onBlur} className="@DeleteButtonField">
      <IconButton
        icon={<Trash2 size={18} />}
        className="@DeleteButton size-input h-full"
        variant="ghost"
        color="failure"
        onPress={handleDeletePress}
        aria-label={t.loadStaged.placeholders.deleteItem}
        isDisabled={disabled}
      />
    </div>
  );
};
